import handlebars from "handlebars";
import { GetAppraisalModel } from "../../../../../all_Interfaces";
import currencySymbolMap from "currency-symbol-map";
import otherAssetTemplate from "../templates/otherAssetsTemplate";

export const compileOtherAssetTemplate = (
    appraisalData:GetAppraisalModel
  ): string => {
    const compiledOtherAssetTemplate = handlebars.compile(otherAssetTemplate);
    const dayjs = require('dayjs');
    const formatNumber = (params:any) => {
        if(params !== null)
          return params.toLocaleString('en-US');
         
        return '';
      }


    var currencySymbol = "$";
    if(appraisalData.currency != "ZH"){
        currencySymbol = currencySymbolMap(appraisalData.currency) as string
    }else{
        currencySymbol = "ZH";
    }
    if(appraisalData.currency == ""){
      currencySymbol = "$";
    }


    const assetsData = {
        assets: [...appraisalData.assets],
        currency:appraisalData.currency,
        currencySymbol : currencySymbol,
        empty: appraisalData.assets.length == 0 ? 'true' : 'false',
    }

    console.log(assetsData);

    return compiledOtherAssetTemplate(assetsData);
}